// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"282":"20d9b4be","344":"20d9b4be","361":"20d9b4be","473":"a6dc47c0","648":"1f772536","765":"20d9b4be","995":"20d9b4be"}[chunkId] + ".css";
};